
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/[toolName]",
      function () {
        return require("private-next-pages/tools/[toolName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/[toolName]"])
      });
    }
  